import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PageContentComponent } from './page-content.component';



@NgModule({
  declarations: [
    PageContentComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PageContentComponent
  ]
})
export class PageContentModule { }
